var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaUsersPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 17.5V12.5M13.3327 15H18.3327M9.99935 12.5H6.66602C5.11288 12.5 4.33631 12.5 3.72374 12.7537C2.90698 13.092 2.25806 13.741 1.91975 14.5577C1.66602 15.1703 1.66602 15.9469 1.66602 17.5M12.916 2.7423C14.1376 3.23679 14.9993 4.43443 14.9993 5.83333C14.9993 7.23224 14.1376 8.42988 12.916 8.92437M11.2493 5.83333C11.2493 7.67428 9.75697 9.16667 7.91602 9.16667C6.07507 9.16667 4.58268 7.67428 4.58268 5.83333C4.58268 3.99238 6.07507 2.5 7.91602 2.5C9.75697 2.5 11.2493 3.99238 11.2493 5.83333Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaUsersPlus);
export default __webpack_public_path__ + "static/media/aa-users-plus.6106162cfd47a8166ddca16e52c2defb.svg";
export { ForwardRef as ReactComponent };